import { useEffect, useState } from 'react';

// Fixed navigation stops at the footer so footer links remain visible and usable.
export default function useFooterBoundary(active = true) {
  const [inset, setInset] = useState(0);
  useEffect(() => {
    if (!active) return;
    const footer = document.querySelector('.app-footer');
    if (!footer) return;
    const measure = () => setInset(Math.min(
      Math.max(0, window.innerHeight - 60),
      Math.max(0, window.innerHeight - footer.getBoundingClientRect().top)
    ));
    measure();
    window.addEventListener('scroll', measure, true);
    window.addEventListener('resize', measure);
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    observer?.observe(document.body);
    observer?.observe(footer);
    return () => {
      window.removeEventListener('scroll', measure, true);
      window.removeEventListener('resize', measure);
      observer?.disconnect();
    };
  }, [active]);
  return inset;
}
